"use strict";

exports.__esModule = true;
exports.parseUrl = parseUrl;
function parseUrl(str) {
  var parser = global.document.createElement("a");
  parser.href = str;
  return parser;
}



//////////////////
// WEBPACK FOOTER
// ./~/auth0-lock/lib/utils/url_utils.js
// module id = 469
// module chunks = 0